import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { RiArrowDropDownLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";
import "./Navbar.css";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [showDrop, setShowDrop] = useState(false);
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDrop(!showDrop);
  };
  const resetStates = () => {
    setClick(false);
    setShowDrop(false);
  };
  const checkShowDrop = () => {
    if (window.innerWidth > 960) {
      setShowDrop(false);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", checkShowDrop);
    return () => {
      window.removeEventListener("resize", checkShowDrop);
    };
  });
  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo">
            by Owen Du
          </Link>
        </div>
        <div className="menu-icon" onClick={() => setClick(!click)}>
          {click ? (
            <FaTimes className="fa-times" />
          ) : (
            <FaBars className="fa-bars" />
          )}
        </div>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link to="/" className="nav-links" onClick={resetStates}>
              About
            </Link>
          </li>
          <li className="nav-item dropdown">
            <Link
              to="/projects"
              className="nav-links dropdown-btn"
              onClick={resetStates}
            >
              Projects
              <div onClick={handleDrop} className="dropdown-icon">
                {showDrop ? <RiArrowDropUpLine /> : <RiArrowDropDownLine />}
              </div>
            </Link>
            <div className={"dropdown-content"}>
              <Link to="/projects/sec" onClick={resetStates}>
                Smallest Enclosing Circle
              </Link>
              <Link to={"blog/dqn"} onClick={resetStates}>
                Reinforcement Learning using DQN
              </Link>
            </div>
          </li>
          {showDrop && (
            <li
              className={`nav-item nav-item-project ${showDrop || "hideDrop"}`}
            >
              <Link
                className="nav-links nav-links-project"
                to="/projects/sec"
                onClick={resetStates}
              >
                Smallest Enclosing Circle
              </Link>
            </li>
          )}
          {showDrop && (
            <li
              className={`nav-item nav-item-project ${showDrop || "hideDrop"}`}
            >
              <Link
                className="nav-links nav-links-project"
                to="/blog/dqn"
                onClick={resetStates}
              >
                Reinforcement Learning using DQN
              </Link>
            </li>
          )}
          <li className="nav-item">
            <Link to="/blog" className="nav-links" onClick={resetStates}>
              Blog
            </Link>
          </li>
        </ul>
        <div style={{ width: "155px" }}></div>
      </nav>
    </>
  );
};

export default Navbar;
